import { render, staticRenderFns } from "./ProductPriceInfos.vue?vue&type=template&id=50d4b83e&scoped=true&"
import script from "./ProductPriceInfos.vue?vue&type=script&lang=js&"
export * from "./ProductPriceInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceInfos.vue?vue&type=style&index=0&id=50d4b83e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4b83e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
